import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    num: '01',
    title: 'Set up your team',
    desc: 'Connect your HRMS, add your team, and map roles to learning goals. Done in a day.',
  },
  {
    num: '02',
    title: 'Assign personalised learning paths',
    desc: 'Magnetix recommends the right courses. Managers assign. Every learner gets a path built for their role — not a one-size-fits-all list.',
  },
  {
    num: '03',
    title: 'Track what actually happened',
    desc: 'See who\'s ready, who isn\'t, and how learning is connecting to performance — for every team, up to the CEO.',
  },
];

export default function HowItWorks() {
  return (
    <section className="how-it-works">
      <div className="how-it-works__container">
        <div className="how-it-works__header">
          <div className="how-it-works__eyebrow">How it works</div>
          <h2 className="how-it-works__heading">
            Up and running in three steps.
          </h2>
        </div>

        <div className="how-it-works__grid">
          {steps.map((step, index) => (
            <div key={index} className="how-it-works__step">
              <div className="how-it-works__num">{step.num}</div>
              <div className="how-it-works__title">{step.title}</div>
              <div className="how-it-works__desc">{step.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
